import { useLocalStorageState } from 'ahooks';
import { Theme } from 'emoji-picker-react';
import { useEffect, useRef, useState } from 'react';

export default function useEmojiPicker() {
  const emojiPickerRef = useRef<HTMLDivElement>(null);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [theme] = useLocalStorageState<string | undefined>('leadsales', {
    listenStorageChange: true,
  });

  const emojiPickerTheme = theme === 'leadsales' ? Theme.LIGHT : Theme.DARK;

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        emojiPickerRef.current &&
        !emojiPickerRef.current.contains(event.target as Node)
      ) {
        setShowEmojiPicker(false);
      }
    }

    if (showEmojiPicker) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showEmojiPicker]);

  return {
    emojiPickerRef,
    showEmojiPicker,
    emojiPickerTheme,
    setShowEmojiPicker,
  };
}
